import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import { Toolbar } from 'primereact/toolbar';
import React, { useRef, useState } from 'react';
import InvitesState from './Context/state';
import ModalCreateInvites from './ModalCreateInvites';
import { generatelink } from './Service/request';

const InvitesScreens = () => {

    const { invites, DeleteInvites } = InvitesState();
    const [createDialog, setCreateDialog] = useState(false);

    const [deleteProductDialog, setDeleteProductDialog] = useState(false);
    const [globalFilter, setGlobalFilter] = useState(null);
    const toast = useRef(null);
    const dt = useRef(null);

    const openNew = () => {
        // setProduct(emptyProduct);
        setCreateDialog(true);
    }

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    <Button label="Novo" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                    {/* <Button label="Delete" icon="pi pi-trash" className="p-button-danger" onClick={confirmDeleteSelected} disabled={!selectedProducts || !selectedProducts.length} /> */}
                </div>
            </React.Fragment>
        );
    };

   const genetareLink = async (rowData) => {
    try {
        
        // Copiar para a área de transferência
        const link = await generatelink(rowData);

         await navigator.clipboard.writeText(link.link);
        
        // Mostrar notificação de sucesso
        toast.current.show({
            severity: 'success',
            summary: 'Sucesso',
            detail: 'Link copiado para a área de transferência!',
            life: 3000
        });
    } catch (error) {
        toast.current.show({
            severity: 'error',
            summary: 'Erro',
            detail: 'Falha ao copiar o link',
            life: 3000
        });
        console.error('Erro ao copiar link:', error);
    }

   }

    const emailBodyTemplate = (rowData) => {
        return (
            <>
                <span className="p-column-title">Email</span>
                {rowData.email}
            </>
        );
    };

  


    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions">
                <Button
                    icon="pi pi-link"
                    className="p-button-rounded p-button-success mr-2"
                    onClick={() => {
                        genetareLink(rowData);
                    }}
                />
                <Button
                    icon="pi pi-trash"
                    className="p-button-rounded p-button-warning mt-2"
                    onClick={() => {
                        setDeleteProductDialog(rowData);
                    }}
                />
            </div>
        );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Gerenciamento de convites pendentes</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                <i className="pi pi-search" />
                <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." />
            </span>
        </div>
    );

    const hideDeleteProductDialog = () => {
        setDeleteProductDialog(false);
    };

    const deleteProductDialogFooter = (rowData) => {
        return (
            <>
                <Button label="Não" icon="pi pi-times" className="p-button-text" onClick={hideDeleteProductDialog} />
                <Button
                    label="Sim"
                    icon="pi pi-check"
                    className="p-button-text"
                    onClick={() => {
                        DeleteInvites(rowData?.visible?.id);
                        hideDeleteProductDialog();
                    }}
                />
            </>
        );
    };

    return (
        <div className="grid crud-demo">
            <div className="col-12">
                <div className="card">
                    <Toast ref={toast} />
                    <Toolbar className="mb-4" left={leftToolbarTemplate}></Toolbar>

                    <DataTable
                        ref={dt}
                        value={invites}
                        // selection={selectedProducts}
                        // onSelectionChange={(e) => setSelectedProducts(e.value)}
                        dataKey="id"
                        paginator
                        rows={10}
                        rowsPerPageOptions={[5, 10, 25]}
                        className="datatable-responsive"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} products"
                        globalFilter={globalFilter}
                        emptyMessage="No products found."
                        header={header}
                        responsiveLayout="scroll"
                    >
                        {/* <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column> */}
                        <Column align={'end'} field="email" header="Email" sortable body={emailBodyTemplate} alignFrozen="right" ></Column>
                        {/* <Column align={'end'} field="price" header="Preço" sortable body={priceBodyTemplate} headerStyle={{ width: '14%', minWidth: '10rem' }}></Column> */}
                        <Column align={'right'} body={actionBodyTemplate}></Column>
                    </DataTable>
                    <ModalCreateInvites invitesDialog={createDialog} hideDialog={() => setCreateDialog(false)} />

                    {/* <ModalCreateUser createDialog={createDialog} hideDialog={() => setCreateDialog(false)}/> */}
                    <Dialog visible={deleteProductDialog} style={{ width: '450px' }} header="Confirm" modal footer={deleteProductDialogFooter} onHide={hideDeleteProductDialog}>
                        <div className="flex align-items-center justify-content-center">
                            <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />

                            <span>
                                Deseja cancelar o convite? <b>{deleteProductDialog.name}</b>
                            </span>
                        </div>
                    </Dialog>

                    {/* <Dialog visible={deleteProductsDialog} style={{ width: '450px' }} header="Confirm" modal footer={deleteProductsDialogFooter} onHide={hideDeleteProductsDialog}>
                        <div className="flex align-items-center justify-content-center">
                            <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                            {product && <span>Are you sure you want to delete the selected products?</span>}
                        </div>
                    </Dialog> */}
                </div>
            </div>
        </div>
    );
};

export default InvitesScreens;
